import { BNBox } from "@bn-monorepo/js-packages";
import { useTheme } from "@mui/material";
import { HiddenOptions } from "./Section";
import styleToObject from "style-to-object";

interface Props {
  sectionContainerStylesOverride?: string;
  imageHidden?: HiddenOptions;
  gridOrder?: number;
  children?: React.ReactNode;
}
const SectionWrapperImage: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { imageHidden, sectionContainerStylesOverride, gridOrder } = props;

  const parsedStylesOverrideObject = sectionContainerStylesOverride
    ? styleToObject(sectionContainerStylesOverride)
    : undefined;

  return (
    <BNBox
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        overflow: "hidden",
        [theme.breakpoints.down("sm")]: {
          display: imageHidden?.smDown ? "none" : undefined,
        },
        [theme.breakpoints.up("sm")]: {
          display: imageHidden?.smUp ? "none" : undefined,
        },
        [theme.breakpoints.up("md")]: {
          order: gridOrder,
        },
      }}
      style={{ ...parsedStylesOverrideObject }}
    >
      {props.children}
    </BNBox>
  );
};

export default SectionWrapperImage;
